import { render, staticRenderFns } from "./popup-recover-password.vue?vue&type=template&id=0ac48602"
import script from "./popup-recover-password.vue?vue&type=script&lang=js"
export * from "./popup-recover-password.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports